module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_studio-b332034c6db1504c06b5ce6b5cfbf4d0.jpg";